// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-container[data-v-1410c5d0]{width:50%;padding:0 2%}@media only screen and (min-width: 600px){.icon-container[data-v-1410c5d0]{width:33%}}", ""]);
// Exports
module.exports = exports;
